import { Link } from '@mui/material';
import styled from 'styled-components';

export const LinkButton = styled(Link)`
  vertical-align: baseline;
  text-transform: capitalize;
`;
